import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import Trans from 'Components/Trans';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import * as Styled from './styles';

const Features = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.MGM);
  return (
    <FlexContainer direction="column" gap="dimension_40">
      <Text type="paragraphs" size="XL_XL_S" color="dark">
        {t('Referral.Header.Features.Title')}
      </Text>
      <Styled.CardContainer justify="center" gap="dimension_32">
        {Array.from({ length: 3 }).map((_, index: number) => (
          <Styled.Card key={`Referral.Header.${index + 1}`} direction="column" align="center">
            <Styled.CardNumber justify="center" align="center">
              <Text color="light" type="headline" size="XS_L_L">
                {index + 1}
              </Text>
            </Styled.CardNumber>
            <FlexContainer direction="column" align="center" gap="dimension_32">
              <img
                src={`${TAXDOWN_ASSETS_DOMAIN}/mgm/mgm_icon_${index + 1}.svg`}
                alt={`mgm_icon_${index + 1}`}
              />
              <Text type="paragraphs" size="L_XL_S" color="dark">
                {t(`Referral.Header.Features.${index + 1}.title`)}
              </Text>
              <Text type="paragraphs" size="S_S_S" color="dark" align="center">
                <Trans
                  i18nKey={`Referral.Header.Features.${index + 1}.description`}
                  ns={locizeNS.MGM}
                />
              </Text>
            </FlexContainer>
          </Styled.Card>
        ))}
      </Styled.CardContainer>
    </FlexContainer>
  );
};

export default Features;
